import { render } from "./ProductReportPage.vue?vue&type=template&id=11f134fc&scoped=true&ts=true"
import script from "./ProductReportPage.vue?vue&type=script&lang=ts"
export * from "./ProductReportPage.vue?vue&type=script&lang=ts"

import "./ProductReportPage.vue?vue&type=style&index=0&id=11f134fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f134fc"]])

export default __exports__